import React, { Component } from 'react';
import Card from '../../../CardNew';
import { CLASSIC } from '../../constants';
import GeneralRibbonUtils from '../../GeneralRibbonUtils';
import './styles.css';
import { channelIsBlocked } from 'src/components/RibbonGridNew/utis';
import { showModal, MODAL_PIN } from 'src/actions/modal';
import store from '../../../../store';
import { setFromData } from '../../../../actions/navbar';

class RibbonClassic extends Component {
    constructor(props) {
        super(props);
        this.carruselTitle = props.carruselTitle;
        this.items = props.items;
        this.visibleItems = props.visibleItems;
        this.badgesUserType = props.badgesUserType;
        this.ignoreSeenLast = props.ignoreSeenLast;
        this.focusSettings = props.focusSettings;
        this.ribbonId = props.ribbonId;
        this.focusHandler = props.focusHandler;
        this.onClickHandler = props.onClickHandler ? props.onClickHandler : null;
        this.setMetricsEvent = props.setMetricsEvent;
        this.hideInnerTitle = props.hideInnerTitle;
        this.keyDownHandler = props.keyDownHandler;
        this.deleteAction = props.deleteAction;
        this.className = props.className;
        this.title = props.title;
        this.ribbonIndex = props.index;
        this.api = props.api;
        this.dataUpdateMetrics = props.dataUpdateMetrics;
        this.ribbonName = props.ribbonName;
        this.state = {
          visibleItems: props.visibleItems
        };
        this.idsRibbonsUpAndDown = props.idsRibbonsUpAndDown;
    }

    componentWillReceiveProps(nextProps, nextContext) {
      this.setState({visibleItems: nextProps.visibleItems});
    }

    async clickHandler(data) {
        console.log("RibbonClassic ~ clickHandler:", data);
        this.onClickHandler && this.onClickHandler(data);
    }

    render() {
        const { ribbonType } = this.props;
        const { visibleItems } = this.state;

      return (
            <div className="ribbon-items ribbon-classic">
                {visibleItems.map((node, index) => {
                    const node_item = node.item;

                    const canalesBloqueados = store.getState().pinCodes.pin_channel.info;
                    const isChannelBlocked = canalesBloqueados && canalesBloqueados.includes(node_item.group_id);

                    const badges = GeneralRibbonUtils.getBadgesHTML(this.badgesUserType, node_item);
                    const key = Math.random() * 10;
                    let uri = null;
                    const dataMetricsRibbon = {
                        node_item,
                        node_location: location.pathname,
                        ribbon_title: this.props.carruselTitle || this.ribbonId,
                    };

                    if (this.props.type === 'user-profile') {
                        if (node && node_item && node_item.typeContent) {
                            uri = node_item.src;
                        } else {
                            uri = `/socialProfile/${node_item.id}`;
                        }
                    } else {
                        uri = node_item.src;
                    }
                    return (
                        <Card
                            id={index + 1}
                            ribbonId={this.ribbonId}
                            key={key}
                            ignoreSeenLast={this.ignoreSeenLast}
                            data={node_item}
                            group_id={node_item.group_id || node_item.id}
                            cover={node_item.cover}
                            hideTitles={this.props.hideTitles}
                            isRecentActivity={this.props.isRecentActivity}
                            label={node_item.label}
                            type={CLASSIC}
                            onClick={(e) => {
                                this.dataUpdateMetrics(dataMetricsRibbon);
                                if (node_item.type === 'live' || node_item.filterTV) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    this.clickHandler(node_item);
                                }
                            }}
                            ribbonType={ribbonType}
                            ribbonIndex={this.ribbonIndex}
                            title={node_item.title}
                            badges={badges}
                            dataMetric={{
                                carruselTitle: this.carruselTitle,
                                cardPosition: GeneralRibbonUtils.getPosition(
                                    this.items,
                                    node_item.title
                                ),
                            }}
                            focusable={true}
                            focusRight={`#${this.ribbonId} ${this.focusSettings.selector}`}
                            focusLeft={`#${this.ribbonId} ${this.focusSettings.selector}`}
                            focusHandler={this.focusHandler}
                            setMetricsEvent={this.setMetricsEvent}
                            href={uri}
                            hideInnerTitle={this.hideInnerTitle}
                            bookmark={node_item.bookmark ? String(node_item.bookmark) : '0'}
                            filterTV={node_item.filterTV ? node_item.filterTV : null}
                            keyDownHandler={this.keyDownHandler}
                            deleteAction={this.deleteAction}
                            api={this.api}
                            ribbonName={this.ribbonName}
                            ribbonLength= {this.visibleItems.length}
                            idsRibbonsUpAndDown={this.idsRibbonsUpAndDown}
                            isChannelBlocked={isChannelBlocked}
                        />
                    );
                })}
            </div>
        );
    }
}

export default RibbonClassic;



// WEBPACK FOOTER //
// ./src/components/RibbonNew/RibbonTypes/RibbonClassic/index.jsx